export default {
    path : "enterprise-focus",
    name : "enterprise-focus",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/enterprise/focus/Index'),
    redirect: {
        name : "enterprise-focus-whole"
    },
    children: [
        {
            path: 'all',
            name: 'enterprise-focus-whole',
            meta: {
                title: '关注企业-列表页'
            },
            component: () => import('@/pages/enterprise/list/Index'),
        },
        {
            path: 'update',
            name: 'enterprise-focus-update',
            meta: {
                title: '关注企业-列表页'
            },
            component: () => import('@/pages/enterprise/list/Index'),
        },
        {
            path: 'search',
            name: 'enterprise-focus-search',
            meta: {
                title: '关注企业-列表页'
            },
            component: () => import('@/pages/enterprise/list/Index'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/enterprise/focus_enterprise/index.js